// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3yyzc","infoBtn":"quickbooks_infoBtn__3U8V1","formBox":"quickbooks_formBox__2HuUq","formFooter":"quickbooks_formFooter__1slq1"};